import { useRef, useState, useEffect } from 'react'
import { Container, Modal } from 'react-bootstrap'
import { Row, Col } from 'antd'
import { InputGroup, InputLeftAddon, Input } from '@wartek-id/input'
import { Button } from '@wartek-id/button'
import { Helmet } from 'react-helmet'
import '@wartek-id/design-tokens/build/guru-desktop/css/color.css'
import Slider from 'react-slick'
import config from 'app/config'

const Home = ({ clickVideo, clickHelpCenter, inputSearchKeyword, searchSubmit }) => {

  const ref = useRef(null)
  const [isVideoOpen, setIsVideoOpen] = useState(false)
  const [keyword, setKeyword] = useState('')
  const [userPos, setUserPos] = useState({ lat: null, long: null })
  const geolocationAPI = navigator.geolocation

  useEffect(() => {
    geolocationAPI.getCurrentPosition(
      (pos) => {
        const newUserPos = {
          lat: pos.coords.latitude,
          long: pos.coords.longitude,
        }
        setUserPos(newUserPos)
      },
      (err) => {
        console.log(err)
      },
    )
  }, [])

  const settings = {
    dots: true,
    infinite: false,
    slidesToShow: 2,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: '10px',
    arrows: true,
    className: 'slider variable-width',
    variableWidth: true,
    initialSlide: 0,
    responsive: [
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          centerMode: false,
        },
      },
    ],
  }

  const handleClickVideo = () => {
    setIsVideoOpen(true)
    clickVideo()
  }

  const handleClickHelpCenter = () => {
    clickHelpCenter()
  }

  const handleClick = () => {
    ref.current?.scrollIntoView({ top: 100, behavior: 'smooth' })
  }

  const handleInputSearchKeyword = () => {
    inputSearchKeyword()
  }

  const onFormSubmit = (e) => {
    e.preventDefault()
    searchSubmit(keyword)
    if(userPos?.lat !== null && userPos?.long !== null){
      window.open(
        `${config.search_url}?keyword=${keyword}&latitude=${userPos?.lat}&longitude=${userPos?.long}&sort=RELEVANCE`,
        '_blank',
      )
    }else{
      window.open(
        `${config.search_url}?keyword=${keyword}&sort=RELEVANCE`,
        '_blank',
      )
    }
  }
  const searchItem = (item) => {
    searchSubmit(item)
    if(userPos?.lat !== null && userPos?.long !== null){
      window.open(
        `${config.search_url}?keyword=${item}&latitude=${userPos?.lat}&longitude=${userPos?.long}&sort=RELEVANCE`,
        '_blank',
      )
    }else{
      window.open(
        `${config.search_url}?keyword=${item}&sort=RELEVANCE`,
        '_blank',
      )
    }
  }

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Situs informasi SIPLah</title>
        <link rel="canonical" href="siplah.kemendikdasmen.go.id" />
        <meta http-equiv="Cache-control" content="max-age=31536000"></meta>
        <meta charset="UTF-8"></meta>
        <meta name="title" content="Situs informasi SIPLah"></meta>
        <meta
          name="description"
          content="Situs informasi resmi pengadaan barang dan jasa satuan pendidikan Kemendikdasmen."
        ></meta>
      </Helmet>
      <div className="h-100">
        <section className="section-head">
          <Container>
            {/* <h6 style={{marginBottom: "30px", padding: "30px", color: "#EF1616", border: "1px solid #EF1616", backgroundColor: "#FFEEEE", borderRadius: "8px"}}> */}
              {/* <strong>Mulai 16 Desember 2024</strong>
              <br />
              <b>Innolaku (PT Deka Sari Perkasa) tidak lagi dapat menerima transaksi dari satuan pendidikan, dan sistem akan dibekukan.</b> 
              <br/><br/>
              Bagi satuan pendidikan yang memiliki transaksi atau PBJ Belum Selesai di Innolaku, segera selesaikan 
              transaksi paling lambat 13 Desember 2024. */}

              {/* <strong>Halaman Pemetaan Pembelanjaan Telah Dirilis!</strong>
              <br /><br />
              Untuk memudahkan penggunaan Halaman Pemetaan Pembelanjaan (HPP), silakan akses <strong>Buku Panduan dan Video Tutorial HPP</strong> melalui tautan berikut:
              <ol>
                <li>
                  Buku Panduan → <a href="http://bit.ly/PanduanHPPSIPLah" target="_blank" style={{color: '#0D6EFD'}}>bit.ly/PanduanHPPSIPLah</a>
                </li>
                <li>
                  Playlist video terkait manfaat & tutorial HPP → <a href="http://s.id/playlist-hpp-yt" target="_blank" style={{color: '#0D6EFD'}}>s.id/playlist-hpp-yt</a>
                </li>
              </ol> */}
              
              {/* <b>Halaman Pemetaan Pembelanjaan Telah Dirilis!</b>
              <br /><br />
              Mitra melakukan proses perilisan secara bertahap untuk penyelesaian pengembangan mengakomodir HPP. Selama proses penyelesaian berlangsung, satuan pendidikan hanya dapat menyelesaikan transaksi yang sudah berjalan namun belum dapat membuat transaksi baru pada mitra tersebut.
              <br /><br />
              Untuk mendapatkan informasi lebih lanjut terkait mitra yang sudah selesai melakukan pengembangan, silakan untuk mengakses tautan berikut: <a href='https://bit.ly/DaftarMitraSIPLah' target='_blank' style={{color: '#0D6EFD'}}>https://bit.ly/DaftarMitraSIPLah</a>. */}

              {/* <b>SIPLah akan melakukan pemeliharaan sistem pada hari Jumat, 23 Agustus 2024 pukul 17.00-23.59 WIB.</b>
              <br/><br/>
              Pemeliharaan dilakukan karena adanya beberapa kendala yang dialami oleh pengguna saat proses pembelanjaan di SIPLah, Halaman Pemetaan Pembelanjaan (HPP), dan pencatatan BKU ARKAS.
              <br/><br/>
              Pemeliharaan ini akan berdampak pada satuan pendidikan belum dapat membuat pesanan baru pada SIPLah sementara waktu. Mohon maaf atas ketidaknyamanan yang ditimbulkan. Terima kasih telah menunggu.
              <br/><br/>
              Jika Anda memiliki kendala mendesak terkait pengadaan barang dan jasa, hubungi <a href='https://bit.ly/HubungiBantuanSIPLah' target='_blank' style={{color: '#0D6EFD'}}>https://bit.ly/HubungiBantuanSIPLah</a>  
              <br/>
              Dapatkan informasi selanjutnya dengan ikuti Instagram: <a href='https://www.instagram.com/pusdatin_kemendikbudristek/?hl=en' target='_blank' style={{color: '#0D6EFD'}}>@pusdatin_kemendikbudristek</a> <a href='https://www.instagram.com/aplikasi.rkas/?hl=en' target='_blank' style={{color: '#0D6EFD'}}>@aplikasi.rkas</a>. */}
            {/* </h6> */}
            <h6 className="grey-text caption-header m-b-24">
              <b>Selamat datang di SIPLah</b>
            </h6>
            <h1 className="font-switzer-bold m-b-44 width-800">
              <b className="font-light-bold">
                Situs informasi resmi pengadaan barang dan jasa satuan pendidikan
              </b>
            </h1>
            <Row gutter={[16, 16]}>
              <Col xs={24} lg={4} md={6} sm={24} className="m-b-10 p-r-8">
                <a
                  className="button-big-primary align-left font-size-19 d-block"
                  onClick={handleClick}
                >
                  <Row gutter={[16, 16]}>
                    <Col md={24} xs={20} className="p-l-0 p-r-0">
                      <b className="d-none d-lg-block d-xl-block">
                        Pelajari Lebih Lanjut
                      </b>
                      <b className="d-none d-md-block d-lg-none">
                        Pelajari
                        <br />
                        Lebih Lanjut
                      </b>
                      <b className="d-none d-sm-block d-md-none">
                        Pelajari Lebih Lanjut
                      </b>
                      <b className="d-block d-sm-none">Pelajari Lebih Lanjut</b>
                    </Col>
                    <Col
                      md={24}
                      xs={4}
                      className="display-flex align-items-center"
                    >
                      <span className="material-symbols-outlined arrow-button-header-main">
                        arrow_downward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col
                xs={24}
                lg={10}
                md={8}
                sm={24}
                className="m-b-10 p-l-8 p-r-8"
              >
                <a
                  className="button-big-secondary d-block"
                  href="/satuan-pendidikan"
                >
                  <Row gutter={[16, 16]}>
                    <Col
                      lg={18}
                      md={24}
                      xs={20}
                      sm={24}
                      className="p-l-0 p-r-0"
                    >
                      <div className="font-size-17 font-light-bold">
                        SIPLah untuk
                      </div>
                      <b className="font-size-19 font-boldest">
                        Satuan Pendidikan
                      </b>
                    </Col>
                    <Col
                      lg={6}
                      md={24}
                      xs={24}
                      sm={24}
                      className="d-none d-lg-block text-right"
                    >
                      <img
                        src="./assets/homepage/satdik-icon.svg"
                        alt="penyedia_barang"
                        className="img-icon"
                      />
                    </Col>
                    <Col
                      md={24}
                      xs={4}
                      className="display-flex align-items-center font-size-22"
                    >
                      <span className="material-symbols-outlined arrow-button-header">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col
                xs={24}
                lg={10}
                md={8}
                sm={24}
                className="m-b-10 p-l-8 p-r-8"
              >
                <a
                  className="button-big-secondary d-block"
                  href="/penyedia-barang-jasa"
                >
                  <Row gutter={[16, 16]}>
                    <Col
                      lg={18}
                      md={24}
                      xs={20}
                      sm={24}
                      className="p-l-0 p-r-0"
                    >
                      <div className="font-size-17 font-light-bold">
                        SIPLah untuk
                      </div>
                      <b className="font-size-19 font-boldest">Penyedia</b>
                    </Col>
                    <Col
                      lg={6}
                      md={24}
                      xs={24}
                      sm={24}
                      className="d-none d-lg-block text-right"
                    >
                      <img
                        src="./assets/homepage/penyedia-icon.svg"
                        alt="penyedia_barang"
                        className="img-icon"
                      />
                    </Col>
                    <Col
                      md={24}
                      xs={4}
                      className="display-flex align-items-center font-size-22"
                    >
                      <span className="material-symbols-outlined arrow-button-header">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
            </Row>
          </Container>
          <div
            className="text-center header-image m-t-64"
            style={{
              backgroundImage: 'url(./assets/homepage/banner-siplah.svg)',
            }}
          ></div>
        </section>
        <div ref={ref} style={{ scrollMargin: '65px' }}></div>
        <section className="section-apa-itu-siplah">
          <Container className="gap-apa-itu-siplah">
            <h2 className="font-switzer-semibold m-b-24">
              <b className="font-bolder">Apa itu SIPLah</b>
            </h2>
            <Row gutter={[16, 16]}>
              <Col
                lg={16}
                md={18}
                sm={16}
                xs={24}
                className="align-items-center"
              >
                <h4 className="m-b-16 font-light-bold">
                  Sistem Informasi Pengadaan Sekolah (SIPLah) adalah sistem
                  digital dari Kemendikdasmen yang membantu satuan pendidikan{' '}
                  <b className="font-boldest">(Satdik) berbelanja</b>{' '}
                  kebutuhannya{' '}
                  <b className="font-boldest">dari Penyedia barang dan jasa</b>{' '}
                  yang tergabung{' '}
                  <b className="font-boldest">
                    dalam Mitra pengelola pasar daring
                  </b>{' '}
                  SIPLah.
                </h4>
                <div className="font-size-16 m-t-10 m-b-20">
                  Seluruh aktivitas pelaksanaan SIPLah telah memenuhi syarat dan
                  diatur dalam Permendikbud Nomor 18 Tahun 2022.
                </div>
              </Col>
              <Col
                lg={8}
                md={6}
                sm={8}
                xs={24}
                className="align-items-center text-center position-relative"
              >
                <div className="">
                  <a onClick={() => handleClickVideo()}>
                    <span className="material-icons text-blue button-play-video">
                      play_circle_filled
                    </span>
                  </a>
                </div>
                <div className="m-t-10">
                  <img
                    src="./assets/homepage/play-video.svg"
                    alt="play-video"
                    className="img-play-video"
                  />
                </div>
                <div className="m-t-10 text-center">
                  <a className="play-video" onClick={() => handleClickVideo()}>
                    Tonton Video tentang SIPLah
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
        <section className="section-body">
          <div className="gap bg-blue-sky">
            <Container>
              <Row gutter={[16, 16]}>
                <Col md={24} sm={24} xs={24}>
                  <h2 className="font-switzer-semibold m-b-24">
                    <b className="font-bolder">
                      Barang dan jasa yang tersedia di SIPLah
                    </b>
                  </h2>
                  <div className="font-size-20-16 m-b-32">
                    Dengan lebih dari <b className="font-boldest">12 juta</b>{' '}
                    produk yang dijual di SIPLah, Satdik dapat dengan leluasa
                    menentukan pilihan berdasarkan harga dan kualitas terbaik.
                  </div>
                </Col>
                <Col
                  md={24}
                  xs={24}
                  sm={24}
                  className="display-flex align-items-start"
                >
                  <form onSubmit={onFormSubmit} className="form-search">
                    <InputGroup>
                      <InputLeftAddon>
                        <span className="material-symbols-outlined">
                          search
                        </span>
                      </InputLeftAddon>
                      <Input
                        placeholder="Contoh pencarian: buku matematika, papan tulis, tinta printer, jasa fotokopi..."
                        onChange={(e) => setKeyword(e.target.value)}
                        onClick={() => handleInputSearchKeyword()}
                        value={keyword}
                        type="search"
                      />
                    </InputGroup>
                    <Button
                      color="blue"
                      size="md"
                      variant="solid"
                      className="m-l-10 button-cari"
                      type="submit"
                    >
                      Cari
                    </Button>
                  </form>
                </Col>
                <Col md={24} sm={24} xs={24} className="m-t-28">
                  <Row gutter={[16, 16]} className="align-items-center">
                    <Col lg={4} md={24} sm={24} xs={24}>
                      <b className="font-boldest font-size-16">
                        Kategori paling dicari:
                      </b>
                    </Col>
                    <Col lg={20} md={24} sm={24} xs={24}>
                      <div className="category-margin">
                        <button
                          className="button-product"
                          onClick={() => searchItem('Alat Tulis Kantor')}
                        >
                          Alat Tulis Kantor{' '}
                          <span className="material-symbols-outlined font-size-20">
                            arrow_forward
                          </span>
                        </button>
                        <button
                          className="button-product"
                          onClick={() => searchItem('Buku')}
                        >
                          Buku{' '}
                          <span className="material-symbols-outlined font-size-20">
                            arrow_forward
                          </span>
                        </button>
                        <button
                          className="button-product"
                          onClick={() => searchItem('Elektronik')}
                        >
                          Elektronik{' '}
                          <span className="material-symbols-outlined font-size-20">
                            arrow_forward
                          </span>
                        </button>
                        <button
                          className="button-product"
                          onClick={() => searchItem('Pertukangan')}
                        >
                          Pertukangan{' '}
                          <span className="material-symbols-outlined font-size-20">
                            arrow_forward
                          </span>
                        </button>
                        <button
                          className="button-product"
                          onClick={() => searchItem('Rumah Tangga')}
                        >
                          Rumah Tangga{' '}
                          <span className="material-symbols-outlined font-size-20">
                            arrow_forward
                          </span>
                        </button>
                        <button
                          className="button-product"
                          onClick={() => searchItem('Kesehatan')}
                        >
                          Kesehatan{' '}
                          <span className="material-symbols-outlined font-size-20">
                            arrow_forward
                          </span>
                        </button>
                      </div>
                    </Col>
                  </Row>
                </Col>
              </Row>
            </Container>
          </div>
        </section>
        <section className="section-body">
          <Container>
            <div>
              <h2 className="font-switzer-semibold gap-text-header-64">
                <b className="font-bolder">
                  Keuntungan utama menggunakan SIPLah
                </b>
              </h2>
              <Row gutter={[16, 16]}>
                <Col lg={8} md={12} sm={12} xs={24}>
                  <div className="width-328">
                    <img
                      src="./assets/homepage/berkas-terdokumentasi.svg"
                      alt="satuan_pendidikan"
                      width="60"
                      className="m-b-20"
                    />
                    <div className="font-size-22 m-b-12">
                      <b>Berkas Terdokumentasi</b>
                    </div>
                    <div className="grey-text font-size-16 gap-bottom-32">
                      Di SIPLah, setiap bukti yang dibutuhkan untuk
                      pertanggungjawaban secara otomatis terdokumentasi dan bisa
                      diunduh.
                    </div>
                  </div>
                </Col>
                <Col lg={8} md={12} sm={12} xs={24}>
                  <div className="width-328">
                    <img
                      src="./assets/homepage/produk-sesuai-kebutuhan.svg"
                      alt="satuan_pendidikan"
                      width="60"
                      className="m-b-20"
                    />
                    <div className="font-size-22 m-b-12">
                      <b>Produk Sesuai Kebutuhan</b>
                    </div>
                    <div className="grey-text font-size-16 gap-bottom-32">
                      Barang dan jasa yang ditawarkan di SIPLah sudah terseleksi
                      dan sesuai dengan kebutuhan Satdik.
                    </div>
                  </div>
                </Col>
                <Col lg={8} md={12} sm={12} xs={24}>
                  <div className="width-328">
                    <img
                      src="./assets/homepage/data-terintegrasi.svg"
                      alt="satuan_pendidikan"
                      width="60"
                      className="m-b-20"
                    />
                    <div className="font-size-22 m-b-12">
                      <b>Data Terintegrasi</b>
                    </div>
                    <div className="grey-text font-size-16">
                      SIPLah terintegrasi dengan Dapodik dan akan terus
                      dikembangkan untuk terhubung dengan sistem administrasi
                      lainnya.
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Container>
        </section>
        <hr className="gap-text-header-50" />
        <section className="section-body">
          <Container>
            <h2 className="font-switzer-semibold m-b-24">
              <b>Kata mereka yang sudah menggunakan SIPLah</b>
            </h2>
            <div
              className="font-size-20 text-justify"
              style={{ marginBottom: '100px' }}
            >
              SIPLah telah menghubungkan lebih dari{' '}
              <b className="font-boldest">223.000 Satdik</b> dengan{' '}
              <b className="font-boldest">100.000 Penyedia barang dan jasa </b>
              melalui{' '}
              <b className="font-boldest">
                15 Mitra pengelola pasar daring
              </b>{' '}
              dari seluruh Indonesia. Berikut beberapa pengalaman mereka.
            </div>
          </Container>
        </section>
        <section className="bg-dark-blue">
          <Container className="position-relative container-slider p-b-44 height-step">
            <div className="position-relative m-t-30 slider-homepage container-slider-main">
              <Slider {...settings}>
                <div
                  className="why-use-siplah m-t-10 m-b-10 why-height"
                  style={{ width: 512 }}
                >
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-1.png"
                        alt="quotes"
                        width="27"
                        className="m-b-24"
                      />
                      <div className="font-size-22-20 m-b-30">
                        Penggunaan SIPLah juga tidak sulit dan bisa dipelajari
                        dengan gampang karena secara{' '}
                        <span className="bg-light-orange">
                          fitur mirip seperti <i>e-commerce</i> lain
                        </span>
                        . Berbelanja di SIPLah aman karena bisa bayar setelah
                        menerima barang.
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-general-1.png"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b className="font-boldest">Opik Hidayat</b>
                        <div className="grey-text">
                          Pelaksana PBJ SDN Jayagiri Lembang <span>&#183;</span>{' '}
                          Satuan Pendidikan
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div
                  className="why-use-siplah m-t-10 m-b-10 why-height"
                  style={{ width: 512 }}
                >
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-4.png"
                        alt="quotes"
                        width="27"
                        className="m-b-24"
                      />
                      <div className="font-size-22-20 m-b-30">
                        Sebagai penyedia SIPLah, saya merasa bisa berkontribusi
                        membantu Sekolah dalam memenuhi kebutuhan barang. Sejauh
                        ini SIPLah juga cukup mudah digunakan dan{' '}
                        <span className="bg-light-orange">
                          proses pencairan dana juga cukup lancar
                        </span>
                        .
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-general-4.png"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b className="font-boldest">Bagiya Gunarto </b>
                        <div className="grey-text">
                          CV Duta Arifah Indonesia Prov Sulawesi Selatan{' '}
                          <span>&#183;</span> Penyedia
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div
                  className="why-use-siplah m-t-10 m-b-10 why-height"
                  style={{ width: 512 }}
                >
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-2.png"
                        alt="quotes"
                        width="27"
                        className="m-b-24"
                      />
                      <div className="font-size-22-20 m-b-30">
                        Berbelanja di SIPLah ini terjamin dalam pemeriksaan dan
                        pajaknya, kami sekolah merasa aman.{' '}
                        <span className="bg-light-orange">
                          Barangnya pun sejauh ini sesuai dengan harapan
                        </span>
                        .
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-general-2.png"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b className="font-boldest">Vivan</b>
                        <div className="grey-text">
                          Pelaksana PBJ SMA 5 Halmahera Utara Maluku{' '}
                          <span>&#183;</span> Satuan Pendidikan
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div
                  className="why-use-siplah m-t-10 m-b-10 why-height"
                  style={{ width: 512 }}
                >
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-5.png"
                        alt="quotes"
                        width="27"
                        className="m-b-24"
                      />
                      <div className="font-size-22-20 m-b-30">
                        <span className="bg-light-orange">
                          Proses administrasi kami sekarang jadi lebih cepat
                        </span>
                        . SIPLah sudah membantu kami untuk mengikuti perubahan
                        tatakelola bertransaksi dari yang tadinya <i>offline</i>{' '}
                        sekarang memakai aplikasi <i>online</i>.
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-general-5.png"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b className="font-boldest">Deni Sonjaya </b>
                        <div className="grey-text">
                          CV Cerdas Jawa Barat <span>&#183;</span> Penyedia
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div
                  className="why-use-siplah m-t-10 m-b-10 why-height"
                  style={{ width: 512 }}
                >
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-3.png"
                        alt="quotes"
                        width="27"
                        className="m-b-24"
                      />
                      <div className="font-size-22-20 m-b-30">
                        Dokumen pelaporan hanya tinggal download sehingga jadi
                        lebih praktis dan simpel. Semua arsip sudah
                        terdokumentasi jadi{' '}
                        <span className="bg-light-orange">
                          nggak takut kehilangan bukti fisik belanja
                        </span>
                        .
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-general-3.png"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b className="font-boldest">Yayat</b>
                        <div className="grey-text">
                          Pelaksana PBJ SDN 4 Cibodas <span>&#183;</span> Satuan
                          Pendidikan
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div
                  className="why-use-siplah m-t-10 m-b-10 why-height"
                  style={{ width: 512 }}
                >
                  <div className="inside-quote">
                    <div>
                      <img
                        src="./assets/quotes/quotes-6.png"
                        alt="quotes"
                        width="27"
                        className="m-b-24"
                      />
                      <div className="font-size-22-20 m-b-30">
                        Yang saya suka dari SIPLah itu{' '}
                        <span className="bg-light-orange">
                          verifikasi pembayaran cepat, sistem transaksi yang
                          mudah terpantau (status jelas)
                        </span>
                        , bantuannya juga cukup <i>fast response</i>.
                      </div>
                    </div>
                    <Row gutter={[16, 16]} className="align-items-center">
                      <Col
                        lg={4}
                        md={6}
                        sm={6}
                        xs={6}
                        className="p-r-0 text-right"
                      >
                        <img
                          src="./assets/quotes/ava-general-6.png"
                          alt="quotes"
                          className="img-quotes"
                        />
                      </Col>
                      <Col
                        lg={20}
                        md={18}
                        sm={18}
                        xs={18}
                        className="p-l-0 text-left"
                      >
                        <b className="font-boldest">Adi Kristianto </b>
                        <div className="grey-text">
                          CV Andi Offset DI Yogyakarta <span>&#183;</span>{' '}
                          Penyedia
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
              </Slider>
            </div>
          </Container>
        </section>
        <section className="section-body-2">
          <Container>
            <h2 className="font-switzer-semibold m-b-24">
              <b>Cara kerja SIPLah</b>
            </h2>
            <div className="font-size-cara-kerja-siplah d-none d-md-block text-justify m-b-64">
              Secara ringkas, Satdik membeli kebutuhan mereka di Penyedia
              penjual barang dan jasa melalui situs Mitra pengelola pasar daring
              SIPLah. Simak infografis di bawah untuk penjelasan lebih detail.
            </div>
            <img
              src="./assets/homepage/cara-kerja-siplah.svg"
              className="img-block d-none d-md-block"
              alt="cara-kerja-siplah"
            />
            <Row gutter={[16, 16]} className="m-t-100 align-items-center">
              <Col md={12} sm={24} xs={24} id="second">
                <div className="width-480">
                  <div className="text-primary font-size-14 m-b-16 m-t-20">
                    <b>LANGKAH 1</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>
                      Satdik berbelanja di situs Mitra pengelola pasar daring
                    </b>
                  </h3>
                  <div className="grey-text font-size-16 m-t-10 text-justify">
                    Setiap Mitra pengelola pasar daring memiliki ratusan
                    Penyedia barang dan jasa yang menjual kebutuhan Satdik.
                    Satdik bisa menentukan pilihan berdasarkan lokasi, harga,
                    atau spesifikasi.
                  </div>
                </div>
              </Col>
              <Col md={2} sm={2} xs={24}></Col>
              <Col md={10} sm={24} xs={24} className="text-center" id="first">
                <img
                  src="./assets/homepage/cara-kerja-1.svg"
                  alt="cara-kerja-1"
                  className="img-block"
                />
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="m-t-90 align-items-center">
              <Col md={12} sm={24} xs={24} id="second">
                <div className="width-480">
                  <div className="text-primary font-size-14 m-b-16 m-t-20">
                    <b>LANGKAH 2</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>Penyedia memproses pesanan dari Satdik</b>
                  </h3>
                  <div className="grey-text font-size-16 m-t-10 text-justify">
                    Setelah terjadi kesepakatan harga, waktu pengiriman dan
                    termin pembayaran antara Penyedia dan Satdik, Penyedia akan
                    memproses dan mengirimkan pesanan melalui kurir rekanan
                    Mitra pengelola pasar daring.
                  </div>
                </div>
              </Col>
              <Col md={2} sm={2} xs={24}></Col>
              <Col md={10} sm={24} xs={24} className="text-center" id="first">
                <img
                  src="./assets/homepage/cara-kerja-2.svg"
                  alt="cara-kerja-2"
                  className="img-block"
                />
              </Col>
            </Row>
            <Row gutter={[16, 16]} className="m-t-90 align-items-center">
              <Col md={12} sm={24} xs={24} id="second">
                <div className="width-480">
                  <div className="text-primary font-size-14 m-b-16 m-t-20">
                    <b>LANGKAH 3</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>Satdik menerima, memeriksa, dan membayar pesanan</b>
                  </h3>
                  <div className="grey-text font-size-16 m-t-10 text-justify">
                    Jika pesanan yang diterima sesuai spesifikasi, Satdik dapat
                    melakukan pembayaran melalui bank atau transfer ke{' '}
                    <i>virtual account</i> ke pihak Mitra pengelola pasar
                    daring.
                  </div>
                </div>
              </Col>
              <Col md={2} sm={2} xs={24}></Col>
              <Col md={10} sm={24} xs={24} className="text-center" id="first">
                <img
                  src="./assets/homepage/cara-kerja-3.svg"
                  alt="cara-kerja-3"
                  className="img-block"
                />
              </Col>
            </Row>
            <Row
              gutter={[16, 16]}
              className="gap-header-homepage-90 align-items-center"
            >
              <Col md={12} sm={24} xs={24} id="second">
                <div className="width-480">
                  <div className="text-primary font-size-14 m-b-16 m-t-20">
                    <b>LANGKAH 4</b>
                  </div>
                  <h3 className="m-b-16">
                    <b>
                      Penyedia menerima pembayaran dari Mitra pengelola pasar
                      daring
                    </b>
                  </h3>
                  <div className="grey-text font-size-16 m-t-10 text-justify">
                    Mitra pengelola pasar daring akan memeriksa kelengkapan
                    dokumen serah terima. Jika tidak ada kendala, Penyedia akan
                    menyalurkan pembayaran ke rekening Penyedia.
                  </div>
                </div>
              </Col>
              <Col md={2} sm={2} xs={24}></Col>
              <Col md={10} sm={24} xs={24} className="text-center" id="first">
                <img
                  src="./assets/homepage/cara-kerja-4.svg"
                  alt="cara-kerja-4"
                  className="img-block"
                />
              </Col>
            </Row>
          </Container>
        </section>
        <section className="gap-container-64 bg-dark-blue">
          <Container>
            <h2 className="font-switzer-reguler m-b-44 text-white">
              <b>Sampai saat ini, SIPLah sudah menjangkau lebih dari</b>
            </h2>
            <Row gutter={[16, 16]}>
              <Col lg={8} md={12} sm={12} xs={24} className="p-l-0 p-r-0">
                <div className="why-use-siplah align-items-center text-center box-1 container-tabulation">
                  <div className="font-switzer-semibold m-b-12 text-numbering-accumulative">
                    <b className="font-bolder">223 Ribu</b>
                  </div>
                  <div className="text-for-achievement">Satuan Pendidikan</div>
                </div>
              </Col>
              <Col lg={8} md={12} sm={12} xs={24} className="p-l-0 p-r-0">
                <div className="why-use-siplah align-items-center text-center box-2 container-tabulation">
                  <div className="font-switzer-semibold m-b-12 text-numbering-accumulative">
                    <b className="font-bolder">34</b>
                  </div>
                  <div className="text-for-achievement">Provinsi</div>
                </div>
              </Col>
              <Col lg={8} md={12} sm={12} xs={24} className="p-l-0 p-r-0">
                <div className="why-use-siplah align-items-center text-center box-3 container-tabulation">
                  <div className="font-switzer-semibold m-b-12 text-numbering-accumulative">
                    <b className="font-bolder">494</b>
                  </div>
                  <div className="text-for-achievement">Kabupaten/Kota</div>
                </div>
              </Col>
              <Col lg={8} md={12} sm={12} xs={24} className="p-l-0 p-r-0">
                <div className="why-use-siplah align-items-center text-center box-4 container-tabulation">
                  <div className="font-switzer-semibold m-b-12 text-numbering-accumulative">
                    <b className="font-bolder">100 Ribu</b>
                  </div>
                  <div className="text-for-achievement">
                    Penyedia barang dan jasa
                  </div>
                </div>
              </Col>
              <Col lg={8} md={12} sm={12} xs={24} className="p-l-0 p-r-0">
                <div className="why-use-siplah align-items-center text-center box-5 container-tabulation">
                  <div className="font-switzer-semibold m-b-12 text-numbering-accumulative">
                    <b className="font-bolder">10 Trilyun</b>
                  </div>
                  <div className="text-for-achievement">
                    Total nominal transaksi
                  </div>
                </div>
              </Col>
              <Col lg={8} md={12} sm={12} xs={24} className="p-l-0 p-r-0">
                <div className="why-use-siplah align-items-center text-center box-6 container-tabulation">
                  <div className="font-switzer-semibold m-b-12 text-numbering-accumulative">
                    <b className="font-bolder">12 Juta</b>
                  </div>
                  <div className="text-for-achievement">Produk terjual</div>
                </div>
              </Col>
            </Row>
            <div className="m-t-24 line-height-20 text-white-smoke text-caption">
              *Berdasarkan data Oktober 2022 dan akan terus diperbarui{' '}
            </div>
          </Container>
        </section>
        <section className="bg-white-smoke m-t-20">
          <Container className="container-bantuan-kami">
            <Row gutter={[16, 16]} className="align-items-center">
              <Col lg={13} md={15} sm={24} xs={24}>
                <h2 className="font-switzer-reguler gap-text-64-24">
                  <b>SIPLah siap membantu dan memandu Anda</b>
                </h2>
                <div className="font-size-20 m-b-32">
                Jika Anda memiliki pertanyaan atau mencari informasi terkait penggunaan SIPLah, Anda dapat mengunjungi Pusat Bantuan dan mencari topik yang dibutuhkan.
                </div>
                <a
                  href="https://pusatinformasi.rumahpendidikan.kemendikdasmen.go.id/hc/id/categories/52400503427609-SIPLah"
                  target="_blank"
                  className="button-hubungi-kami gap-button-hubungi-kami"
                  onClick={() => handleClickHelpCenter()}
                >
                  <b>Kunjungi Pusat Bantuan</b>
                </a>
              </Col>
              <Col lg={1} md={1} sm={24} xs={24}></Col>
              <Col
                lg={10}
                md={8}
                sm={24}
                xs={24}
                className="d-none d-md-block bg-pusat-bantuan height-layanan"
                style={{
                  backgroundImage:
                    'url(./assets/homepage/img-pusat-bantuan-section.png)',
                }}
              ></Col>
            </Row>
          </Container>
        </section>
        <section className="section-body-last">
          <Container>
            <div className="font-switzer-semibold gap-text-header-44 text-numbering-accumulative">
              <b className="font-bolder">Cari tahu SIPLah lebih lanjut</b>
            </div>
            <Row gutter={[16, 16]}>
              <Col xs={24} md={12} sm={12} className="m-b-12">
                <a
                  className="button-big-secondary d-block"
                  href="/satuan-pendidikan"
                >
                  <Row gutter={[16, 16]} className="align-items-center">
                    <Col lg={18} md={20} xs={20} sm={20}>
                      <div className="font-size-17 font-light-bold">
                        Sebagai
                      </div>
                      <b className="font-size-19 font-boldest">
                        Satuan Pendidikan
                      </b>
                    </Col>
                    <Col
                      lg={6}
                      md={24}
                      xs={24}
                      sm={24}
                      className="d-none d-lg-block text-right"
                    >
                      <img
                        src="./assets/homepage/satdik-icon.svg"
                        alt="penyedia_barang"
                        className="img-icon"
                      />
                    </Col>
                    <Col
                      md={24}
                      xs={4}
                      className="display-flex align-items-center"
                    >
                      <span className="material-symbols-outlined arrow-button-header font-size-32 font-bold">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
              <Col xs={24} md={12} sm={12} className="m-b-12">
                <a
                  className="button-big-secondary d-block"
                  href="/penyedia-barang-jasa"
                >
                  <Row gutter={[16, 16]} className="align-items-center">
                    <Col lg={18} md={20} xs={20} sm={20}>
                      <div className="font-size-17 font-light-bold">
                        Sebagai
                      </div>
                      <b className="font-size-19 font-boldest">
                        Penyedia Barang dan Jasa
                      </b>
                    </Col>
                    <Col
                      lg={6}
                      md={24}
                      xs={24}
                      sm={24}
                      className="d-none d-lg-block text-right"
                    >
                      <img
                        src="./assets/homepage/penyedia-icon.svg"
                        alt="penyedia_barang"
                        className="img-icon"
                      />
                    </Col>
                    <Col
                      md={24}
                      xs={4}
                      className="display-flex align-items-center"
                    >
                      <span className="material-symbols-outlined arrow-button-header font-size-32 font-bold">
                        arrow_forward
                      </span>
                    </Col>
                  </Row>
                </a>
              </Col>
            </Row>
          </Container>
        </section>
        <div className="display-flex overflow-x-hidden">
          <span className="line-upper-footer bg-blue" />
          <span className="line-upper-footer bg-orange" />
          <span className="line-upper-footer bg-green" />
          <span className="line-upper-footer bg-pink" />
        </div>
      </div>
      <Modal
        show={isVideoOpen}
        onHide={() => setIsVideoOpen(false)}
        className="modal-video"
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header className="align-right">
          <a onClick={() => setIsVideoOpen(false)}>
            <span className="material-symbols-outlined text-white font-size-20">
              close
            </span>
          </a>
        </Modal.Header>
        <div className="video-container">
          <iframe
            src="https://www.youtube.com/embed/mpYtDM09RPc?autoplay=1"
            frameBorder="0"
            allow="autoplay; encrypted-media"
            allowFullScreen
            width="800"
            height="449"
            title="video"
          />
        </div>
      </Modal>
    </>
  )
}

export default Home
